"use strict";

exports.__esModule = true;
exports.default = exports.getImageStyles = exports.getImageCropStyle = exports.getImageCoverStyle = exports.getImageContainStyle = exports.getImageFiltersStyle = void 0;

var _duotone = _interopRequireDefault(require("../filters/duotone.svg"));

var _vignette = _interopRequireDefault(require("../filters/vignette.svg"));

var _grayscale = _interopRequireDefault(require("../filters/grayscale.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const getImageFiltersStyle = ({
  imageFilters
}) => {
  if (!imageFilters) {
    return;
  }

  let brightness = imageFilters.brightness,
      contrast = imageFilters.contrast,
      saturation = imageFilters.saturation,
      opacity = imageFilters.opacity,
      blur = imageFilters.blur,
      duotone = imageFilters.duotone,
      vignette = imageFilters.vignette,
      grayscale = imageFilters.grayscale;
  let filters = [];

  if (duotone) {
    filters.push('url(' + _duotone.default + '#filter)');
  }

  if (vignette) {
    filters.push('url(' + _vignette.default + '#filter)');
  }

  if (grayscale) {
    filters.push('url(' + _grayscale.default + '#filter)');
  }

  if (brightness) {
    brightness = brightness + 100;
    filters.push('brightness(' + brightness + '%)');
  }

  if (contrast) {
    contrast = contrast + 100;
    filters.push('contrast(' + contrast + '%)');
  }

  if (saturation) {
    saturation = saturation + 100;
    filters.push('saturate(' + saturation + '%)');
  }

  if (opacity) {
    filters.push('opacity(' + opacity + '%)');
  }

  if (blur) {
    filters.push('blur(' + blur + 'px)');
  }

  if (!filters) {
    return undefined;
  }

  return {
    filter: filters.join(' ')
  };
};

exports.getImageFiltersStyle = getImageFiltersStyle;

const getImageContainStyle = ({
  cropRatio,
  cropWidth,
  cropHeight,
  cropX,
  cropY,
  parentRatio,
  parentWidth,
  parentHeight,
  imageRatio,
  imageWidth,
  imageHeight
}) => {
  // horiz or vert
  let cropboxStyle = {};

  if (cropRatio > parentRatio) {
    return {
      width: "100%",
      height: parentWidth / cropWidth * cropHeight + "px"
    };
  } else {
    return {
      width: parentHeight / cropHeight * cropWidth + "px",
      height: "100%"
    };
  }
};

exports.getImageContainStyle = getImageContainStyle;

const getImageCoverStyle = ({
  cropRatio,
  cropWidth,
  cropHeight,
  cropX,
  cropY,
  parentRatio,
  parentWidth,
  parentHeight,
  imageRatio,
  imageWidth,
  imageHeight
}) => {
  // cropbox
  let coverRatio, cropboxStyle;

  if (cropRatio > parentRatio) {
    coverRatio = cropRatio / parentRatio;
    return {
      width: coverRatio * 100 + "%",
      height: "100%",
      marginLeft: (coverRatio * 100 - 100) / 2 * -1 + "%"
    };
  } else {
    coverRatio = parentRatio / cropRatio;
    return {
      width: "100%",
      height: coverRatio * 100 + "%"
    };
  }
};

exports.getImageCoverStyle = getImageCoverStyle;

const getImageCropStyle = ({
  imageWidth,
  imageHeight,
  cropX,
  cropY,
  cropWidth,
  cropHeight
}) => {
  const cropImageWidth = imageWidth / cropWidth * 100;
  const cropImageHeight = imageHeight / cropHeight * 100;
  const cropImageX = cropX / imageWidth * 100 * -1;
  const cropImageY = cropY / imageHeight * 100 * -1;
  const imageTransform = 'translateX(' + cropImageX + '%) translateY(' + cropImageY + '%)';
  return {
    position: 'absolute',
    top: 0,
    right: 'auto',
    bottom: 'auto',
    left: 0,
    width: cropImageWidth + "%",
    height: 'auto',
    maxWidth: 'none',
    maxHeight: 'none',
    transformOrigin: 'top left',
    transform: imageTransform
  };
};

exports.getImageCropStyle = getImageCropStyle;

const getImageStyles = ({
  imageCropdata,
  imageFocalpoint,
  imageFilters,
  objectFit = "contain",
  parentRef,
  imageRef
}) => {
  const parent = parentRef && parentRef.current;
  const parentWidth = parent.offsetWidth;
  const parentHeight = parent.offsetHeight;
  const parentRatio = parentWidth / parentHeight;
  const image = imageRef && imageRef.current;
  const imageWidth = image.naturalWidth;
  const imageHeight = image.naturalHeight;
  const imageRatio = imageWidth / imageHeight;
  const cropX = imageCropdata && imageCropdata.x * imageWidth / 100 || 0;
  const cropY = imageCropdata && imageCropdata.y * imageHeight / 100 || 0;
  const cropWidth = imageCropdata && imageCropdata.width * imageWidth / 100 || imageWidth;
  const cropHeight = imageCropdata && imageCropdata.height * imageHeight / 100 || imageHeight;
  const cropRatio = cropWidth / cropHeight;
  let cropboxStyle = {},
      cropStyle = {},
      filterStyle = {};

  if (objectFit === "contain") {
    cropboxStyle = getImageContainStyle({
      parentWidth,
      parentHeight,
      parentRatio,
      imageWidth,
      imageHeight,
      imageRatio,
      cropX,
      cropY,
      cropWidth,
      cropHeight,
      cropRatio
    });
    cropStyle = getImageCropStyle({
      parentWidth,
      parentHeight,
      parentRatio,
      imageWidth,
      imageHeight,
      imageRatio,
      cropX,
      cropY,
      cropWidth,
      cropHeight,
      cropRatio
    });
  }

  if (objectFit === "cover") {
    cropboxStyle = getImageCoverStyle({
      parentWidth,
      parentHeight,
      parentRatio,
      imageWidth,
      imageHeight,
      imageRatio,
      cropX,
      cropY,
      cropWidth,
      cropHeight,
      cropRatio
    });
    cropStyle = getImageCropStyle({
      parentWidth,
      parentHeight,
      parentRatio,
      imageWidth,
      imageHeight,
      imageRatio,
      cropX,
      cropY,
      cropWidth,
      cropHeight,
      cropRatio
    });
  }

  if (imageFilters) {
    filterStyle = getImageFiltersStyle({
      imageFilters
    });
  }

  const imageStyle = _extends({}, cropStyle, {}, filterStyle);

  return {
    cropbox: cropboxStyle,
    image: imageStyle
  };
};

exports.getImageStyles = getImageStyles;
var _default = getImageStyles;
exports.default = _default;